import React, { useState } from 'react';
import styled, { createGlobalStyle, css } from 'styled-components';

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
  }
`;

const ContactSection = styled.div`
    padding: 0;
    margin: 0;
`;

const StyledFormWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  padding: 80px 20px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.8)), url('/images/slider_4.png');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
`;

const FormsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 80px;
  width: 100%;
  max-width: 1100px;
`;

const FormBox = styled.div`
  display: flex;
  flex-direction: ${({ reverse }) => (reverse ? 'row-reverse' : 'row')};
  background-color: rgba(15, 23, 42, 0.65);
  border-radius: 20px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.7);
  backdrop-filter: blur(16px);
  -webkit-backdrop-filter: blur(16px);
  border: 1px solid rgba(255, 255, 255, 0.1);
  overflow: hidden;

  @media(max-width: 900px) {
    flex-direction: column;
  }
`;

const FormTextSide = styled.div`
  flex: 1;
  background: linear-gradient(135deg, rgba(59, 130, 246, 0.8) 0%, rgba(30, 58, 138, 0.95) 100%);
  color: #fff;
  padding: 50px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  
  h2 {
    font-size: 3.2rem;
    margin-bottom: 24px;
    font-weight: 700;
  }
  p {
    font-size: 1.3rem;
    line-height: 1.8;
    color: rgba(255, 255, 255, 0.9);
  }
`;

const FormSide = styled.div`
  flex: 1.3;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  color: #fff;

  label {
    font-size: 1.05rem;
    font-weight: 500;
    color: rgba(255, 255, 255, 0.8);
    margin-bottom: 8px;
    display: block;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }
`;

const StyledForm = styled.form`
  width: 100%;
`;

const sharedStyles = css`
  background-color: rgba(255, 255, 255, 0.06);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  height: 54px;
  padding: 0 18px;
  margin: 0 0 24px 0;
  font-size: 1.15rem;
  transition: all 0.3s ease;

  &:focus {
    outline: none;
    border-color: ${({ highlight }) => highlight || '#ef4444'};
    background-color: rgba(255, 255, 255, 0.12);
    box-shadow: 0 0 0 3px ${({ highlight }) => (highlight ? highlight + '33' : '#ef444433')};
  }
  
  &::placeholder {
    color: rgba(255, 255, 255, 0.4);
  }

  option {
    background-color: #1e293b;
    color: #fff;
  }
`;

const StyledSelect = styled.select`
  display: block;
  width: 100%;
  ${sharedStyles}
`;

const StyledInput = styled.input`
  display: block;
  width: 100%;
  ${sharedStyles}
`;

const StyledTextArea = styled.textarea`
  display: block;
  width: 100%;
  min-height: 120px;
  resize: vertical;
  font-family: inherit;
  padding: 15px;
  ${sharedStyles}
  height: auto;
`;

const StyledButton = styled.button`
  display: block;
  background: linear-gradient(135deg, #3b82f6 0%, #2563eb 100%);
  color: #fff;
  font-size: 1.25rem;
  border: none;
  border-radius: 8px;
  height: 58px;
  padding: 0 24px;
  cursor: pointer;
  box-sizing: border-box;
  width: 100%;
  margin-top: 10px;
  font-weight: 600;
  box-shadow: 0 4px 14px 0 rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px 0 rgba(0, 0, 0, 0.4);
  }
  &:active {
    transform: translateY(0);
  }
  &:disabled {
    opacity: 0.7;
    cursor: not-allowed;
    transform: none;
  }
`;

const StyledError = styled.div`
  color: #fca5a5;
  font-weight: 600;
  margin: 0 0 20px 0;
  font-size: 0.95rem;
  background: rgba(220, 38, 38, 0.2);
  padding: 12px;
  border-radius: 6px;
  border: 1px solid rgba(220, 38, 38, 0.4);
`;

const StyledSuccess = styled.div`
  color: #86efac;
  font-weight: 600;
  margin: 0 0 20px 0;
  font-size: 0.95rem;
  background: rgba(34, 197, 94, 0.2);
  padding: 12px;
  border-radius: 6px;
  border: 1px solid rgba(34, 197, 94, 0.4);
`;

const initialContactState = {
  name: '',
  email: '',
  message: ''
};

const initialQuoteState = {
  name: '',
  email: '',
  service: '',
  message: ''
};

function App() {
  const [contactState, setContactState] = useState(initialContactState);
  const [contactError, setContactError] = useState('');
  const [contactSuccess, setContactSuccess] = useState('');
  const [isContactLoading, setIsContactLoading] = useState(false);

  const [quoteState, setQuoteState] = useState(initialQuoteState);
  const [quoteError, setQuoteError] = useState('');
  const [quoteSuccess, setQuoteSuccess] = useState('');
  const [isQuoteLoading, setIsQuoteLoading] = useState(false);

  const targetEmail = "prorenovasuomi@gmail.com";

  const handleContactSubmit = e => {
    e.preventDefault();
    let hasError = false;
    for (let key in contactState) {
      if (contactState[key] === '') {
        setContactError(`Please fill out the ${key} field.`);
        hasError = true;
        break;
      }
    }
    if (hasError) return;
    setContactError('');
    setIsContactLoading(true);

    fetch(`https://formsubmit.co/ajax/${targetEmail}`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        name: contactState.name,
        email: contactState.email,
        message: contactState.message,
        _subject: "New Contact Request from Website"
      })
    })
      .then(response => response.json())
      .then(data => {
        setContactSuccess('Your message has been sent successfully! We will be in touch soon.');
        setContactState(initialContactState);
        setIsContactLoading(false);
      })
      .catch(error => {
        setContactError('Failed to send message. Please try again later.');
        setIsContactLoading(false);
      });
  };

  const handleQuoteSubmit = e => {
    e.preventDefault();
    let hasError = false;
    for (let key in quoteState) {
      if (quoteState[key] === '') {
        setQuoteError(`Please fill out the ${key} field.`);
        hasError = true;
        break;
      }
    }
    if (hasError) return;
    setQuoteError('');
    setIsQuoteLoading(true);
    fetch(`https://formsubmit.co/ajax/${targetEmail}`, {
      method: "POST",
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        name: quoteState.name,
        email: quoteState.email,
        service_requested: quoteState.service,
        message: quoteState.message,
        _subject: `New Quote Request for ${quoteState.service}`
      })
    })
      .then(response => response.json())
      .then(data => {
        setQuoteSuccess('Your quote request has been sent! Our team will prepare an estimate for you.');
        setQuoteState(initialQuoteState);
        setIsQuoteLoading(false);
      })
      .catch(error => {
        setQuoteError('Failed to send request. Please try again later.');
        setIsQuoteLoading(false);
      });
  };

  const handleContactInput = e => {
    const { name, value } = e.currentTarget;
    setContactState(prev => ({ ...prev, [name]: value }));
  };

  const handleQuoteInput = e => {
    const { name, value } = e.currentTarget;
    setQuoteState(prev => ({ ...prev, [name]: value }));
  };

  return (
    <ContactSection id='/ContactUs'>
      <GlobalStyle />
      <StyledFormWrapper>
        <FormsContainer>

          <FormBox reverse>
            <FormTextSide>
              <h2>Request a Quote</h2>
              <p>
                Ready to bring your ideas to reality? Let us know what you need—whether it's a complete
                restaurant renovation, custom-built furniture, or a free quote for your next project.
                We are here to tailor a personalized plan just for you. Fill out the form with your service
                requirements and we'll provide a detailed estimate. Let's build something beautiful together!
              </p>
            </FormTextSide>
            <FormSide>
              <StyledForm onSubmit={handleQuoteSubmit}>
                <label htmlFor="name">Full Name</label>
                <StyledInput highlight="#3b82f6" type="text" name="name" placeholder="Moses Lamichane" value={quoteState.name} onChange={handleQuoteInput} />

                <label htmlFor="email">Email Address</label>
                <StyledInput highlight="#3b82f6" type="email" name="email" placeholder="moses@example.com" value={quoteState.email} onChange={handleQuoteInput} />

                <label htmlFor="service">Service Interested In</label>
                <StyledSelect highlight="#3b82f6" name="service" value={quoteState.service} onChange={handleQuoteInput}>
                  <option value="" disabled>Select a service...</option>
                  <option value="Sofa manufacture/repair">Sofa manufacture/repair</option>
                  <option value="Restaurant renovation">Restaurant renovation</option>
                  <option value="Custom Furniture">Custom Furniture</option>
                  <option value="Kitchen renovation">Kitchen renovation</option>
                  <option value="Painting/wallpaper">Painting/wallpaper</option>
                  <option value="Flooring">Flooring</option>
                  <option value="Wooden terrace/deck">Wooden terrace/deck</option>
                  <option value="Other">Others</option>
                </StyledSelect>

                <label htmlFor="message">Project Details</label>
                <StyledTextArea highlight="#3b82f6" name="message" placeholder="Tell us more about your project..." value={quoteState.message} onChange={handleQuoteInput} />

                {quoteError && <StyledError>{quoteError}</StyledError>}
                {quoteSuccess && <StyledSuccess>{quoteSuccess}</StyledSuccess>}

                <StyledButton type="submit" disabled={isQuoteLoading}>
                  {isQuoteLoading ? 'Sending...' : 'Get a Free Quote'}
                </StyledButton>
              </StyledForm>
            </FormSide>
          </FormBox>

          <FormBox>
            <FormTextSide primary>
              <h2>Contact Us</h2>
              <p>
                Have questions about our services or want to learn more about how we can help?
                Reach out to us anytime! We are always ready to provide you with the information you need
                to make your dream construction or renovation project a reality. Drop a quick message
                and we will get back to you shortly.
              </p>
            </FormTextSide>
            <FormSide>
              <StyledForm onSubmit={handleContactSubmit}>
                <label htmlFor="name">Full Name</label>
                <StyledInput highlight="#3b82f6" type="text" name="name" placeholder="Moses Lamichane" value={contactState.name} onChange={handleContactInput} />

                <label htmlFor="email">Email Address</label>
                <StyledInput highlight="#3b82f6" type="email" name="email" placeholder="moses@example.com" value={contactState.email} onChange={handleContactInput} />

                <label htmlFor="message">Your Message</label>
                <StyledTextArea highlight="#3b82f6" name="message" placeholder="How can we assist you?" value={contactState.message} onChange={handleContactInput} />

                {contactError && <StyledError>{contactError}</StyledError>}
                {contactSuccess && <StyledSuccess>{contactSuccess}</StyledSuccess>}

                <StyledButton type="submit" disabled={isContactLoading}>
                  {isContactLoading ? 'Sending...' : 'Send Message'}
                </StyledButton>
              </StyledForm>
            </FormSide>
          </FormBox>

        </FormsContainer>
      </StyledFormWrapper>
    </ContactSection>
  );
}

export default App;